import { KpalTheme } from "../.internal/themes/KpalTheme";
export default KpalTheme;